import type { RepairPermission } from "./onboarding/completed-permission-repair-state";

export const DESKTOP_PERMISSION_NEEDED_EVENT =
  "denker:desktop-permission-needed";

export function requestDesktopPermission(permission: RepairPermission): void {
  window.dispatchEvent(
    new CustomEvent(DESKTOP_PERMISSION_NEEDED_EVENT, {
      detail: { permission },
    }),
  );
}
